import { render, staticRenderFns } from "./ReciewsContainer.vue?vue&type=template&id=6c02f682&scoped=true&"
import script from "./ReciewsContainer.vue?vue&type=script&lang=js&"
export * from "./ReciewsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ReciewsContainer.vue?vue&type=style&index=0&id=6c02f682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c02f682",
  null
  
)

export default component.exports